module.exports = "/_next/static/images/case1-cover-e3c0cf7e82471e921ef684d955a42f7e.jpg";